import * as React from "react";

const IconLogin = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 15 15" fill="none">
    <g clipPath="url(#prefix__clip0)" stroke="#fff">
      <path
        clipRule="evenodd"
        d="M7.576 8.058a3.029 3.029 0 100-6.058 3.029 3.029 0 000 6.058v0z"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M7.5 9c-4.15 0-5.364 2.966-5.489 4.7-.012.166.123.3.289.3h10.4c.166 0 .3-.134.289-.3C12.864 11.967 11.65 9 7.5 9z"
        strokeWidth={2.3}
      />
    </g>
    <defs>
      <clipPath id="prefix__clip0">
        <path fill="#fff" d="M0 0h15v15H0z" />
      </clipPath>
    </defs>
  </svg>
)

export default IconLogin;